import { useQuery } from 'react-query';

import { CreateAccountInput, DiscoveredAccount } from './types';

export default function useDiscovery() {
  return useQuery(
    'discovery',
    async function(): Promise<AuthenticationResponseData> {
      const response = await fetch(`/auth/stytch/discovery`);
      const data: AuthenticationResponseData = await response.json();

      return data;
    },
    {
      refetchOnWindowFocus: false,
    },
  );
}

export type DiscoverResponse = {
  action: 'discover';
  discovered_accounts: Array<DiscoveredAccount>;
};

export type CreateAccountResponse = {
  action: 'create_account';
  proposed_account: CreateAccountInput;
};

export type UnauthorizedResponse = {
  action: 'unauthorized';
  type: string;
};

export type AuthenticationResponseData =
  | DiscoverResponse
  | CreateAccountResponse
  | UnauthorizedResponse;
